/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamTokenResponseData } from './genericApiResponseOralExamTokenResponseData';
import type { GenericApiResponseOralExamTokenResponseMessage } from './genericApiResponseOralExamTokenResponseMessage';
import type { GenericApiResponseOralExamTokenResponsePagination } from './genericApiResponseOralExamTokenResponsePagination';
import type { GenericApiResponseOralExamTokenResponseError } from './genericApiResponseOralExamTokenResponseError';

export interface GenericApiResponseOralExamTokenResponse {
  data?: GenericApiResponseOralExamTokenResponseData;
  message?: GenericApiResponseOralExamTokenResponseMessage;
  pagination?: GenericApiResponseOralExamTokenResponsePagination;
  error?: GenericApiResponseOralExamTokenResponseError;
  statusCode?: number;
}
